let http = (url, config) => {
    return new Promise((resolve, reject) => {
        config = config || {};
        var headers = config.headers || {};
        if (!config.upload) {
            headers['Content-Type'] = headers['Content-Type'] || 'application/json';
            var body = config.body;
            if (body && typeof body !== "string") {
                config.body = JSON.stringify(config.body);
            }
        }

        config.credentials = 'include';
        window.fetch(url, config).then((response) => {
            return response.json();
        }).then((response) => {
            if (!response.error) {
                resolve(response);
            } else {
                reject(new Error(response.error));
            }
        }).catch(reject);
    });
};
export default http;